<template>
  <div class="courseDetails">
    <div class="course-imgs">
      <van-swipe
        class="course-img-swiper"
        :show-indicators="false"
        :loop="false"
        @change="changeCourseVideo"
      >
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <img
            class="course-img"
            :src="item.url"
            alt=""
            v-if="item.type != 'video'"
          />
          <video
            class="course-video"
            id="courseVideo"
            ref="courseVideo"
            controls="controls"
            controlsList="nodownload"
            autoplay="autoplay"
            :poster="!isAndroid ? swiperList[1].url:''"
            x5-video-player-fullscreen="true"
            x5-playsinline
            playsinline
            webkit-playsinline
            :muted="isAndroid"
            v-else
          >
            <source :src="item.url" type="video/mp4" />
            您的浏览器不支持 HTML5 video 标签
          </video>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="course-name">{{ courseDeatil.title }}</div>
    <div class="course-tags">
      <div class="tag" v-for="(item, index) in courseDeatil.tags" :key="index">
        {{ item }}
      </div>
    </div>
    <div class="price-studys" v-if="!flag">
      <div class="price">
        <div class="new-price">¥{{ courseDeatil.promotionPrice }}</div>
      </div>
      <div class="studys">{{ courseDeatil.learnCount }}次学习</div>
    </div>
    <div class="shop-info" @click="toShop" id="shopInfo" v-if="!flag">
      <div class="shop">
        <div class="user-img">
          <img :src="shopMsg.logo" alt="" />
          <div class="shop-name">
            <p>{{ shopMsg.shopName }}的店铺</p>
          </div>
        </div>
        <div class="rg">
          <img src="../assets/img/details/icon-jiantou@2x.png" alt="" />
        </div>
      </div>
    </div>
    <div class="course-main" id="tabs">
      <div class="course-main-top" id="fixedTop">
        <div
          :class="tabIndex == 1 ? 'tab active-tab' : 'tab'"
          @click="changeTab(1)"
        >
          <span>详情</span>
          <div></div>
        </div>
        <div
          v-if="!flag"
          :class="tabIndex == 2 ? 'tab active-tab' : 'tab'"
          @click="toStudyDialog(), changeTab(2)"
        >
          <span>目录</span>
          <div></div>
        </div>
      </div>
      <van-swipe
        class="my-swipe"
        :show-indicators="false"
        :loop="false"
        @change="changeSwiper"
        ref="swiper"
      >
        <van-swipe-item>
          <div class="course-detail" v-if="tabIndex == 1">
            <div v-html="courseDeatil.describtion"></div>
          </div>
        </van-swipe-item>
        <van-swipe-item v-if="!flag">
          <!--单一课程的商品-->
          <div v-if="courseIds.length == 1">
            <!-- 试看课 -->
            <div class="directory" v-if="tabIndex == 2">
              <div class="and-proved">
                <div class="proved-main" data-status="open">
                  <div
                    class="every"
                    v-for="(value, num) in directory[0].courseList"
                    :key="num"
                    @click="toProved(num)"
                  >
                    <div>
                      <img
                        src="../assets/img/details/icon-bofang@2x.png"
                        alt=""
                      />
                      <div>{{ value.title }}</div>
                    </div>
                    <div>
                      <div>试看</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 系列课 -->
            <div class="directory" v-if="tabIndex == 2">
              <div
                class="and-proved"
                v-for="(item, index) in directory[1].courseList"
                :key="index"
              >
                <div class="proved-top" @click="packUp(index, item.lessonId)">
                  <div>第{{ index + 1 }}章节 {{ item.title }}</div>
                  <img
                    ref="triangle"
                    src="../assets/img/details/icon-jiantou@2x (2).png"
                    alt=""
                    style="transform:rotateZ(180deg);"
                  />
                </div>
                <div
                  class="proved-main"
                  ref="provedMain"
                  data-status="close"
                  style="display:none;height:0px;"
                >
                  <div
                    class="every"
                    v-for="(value, num) in listLesson"
                    :key="num"
                    @click="toStudyDialog(value.totalSort)"
                  >
                    <div>
                      <img
                        src="../assets/img/details/icon-bofang@2x.png"
                        alt=""
                      />
                      <div>{{ value.title }}</div>
                    </div>
                    <div>
                      <div
                        style="display: inline-block;margin-right: 10px;"
                      ></div>
                      <img
                        v-if="!courseDeatil.ifPurchase"
                        src="../assets/img/details/icon-suo@2x.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--套餐类型商品仅展示试看视频，以课程隔开-->
          <div v-if="courseIds.length > 1">
            <div class="directory" v-if="tabIndex == 2">
              <div
                class="and-proved"
                v-for="(item, index) in schemeFreeVideoList"
                :key="index"
              >
                <div class="proved-top" @click="packUp(index, item.courseId)">
                  <div>{{ item.courseTitle }}</div>
                  <img
                    ref="triangle"
                    src="../assets/img/details/icon-jiantou@2x (2).png"
                    alt=""
                    style=""
                  />
                </div>
                <div
                  class="proved-main"
                  ref="provedMain"
                  data-status="open"
                  style="height:auto;"
                >
                  <div
                    class="every"
                    v-for="(value, num) in item.list"
                    :key="num"
                    @click="toProved(value.num)"
                  >
                    <div>
                      <img
                        src="../assets/img/details/icon-bofang@2x.png"
                        alt=""
                      />
                      <div>{{ value.title }}</div>
                    </div>
                    <div>
                      <div style="display: inline-block;margin-right: 10px;">
                        试看
                      </div>
                      <!-- <img
                                v-if="!courseDeatil.ifPurchase"
                                src="../assets/img/details/icon-suo@2x.png"
                                alt=""
                        /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 非系列课 -->
          <div class="directory" v-if="false">
            <div class="and-proved">
              <div class="proved-top">
                <div>试看</div>
                <img
                  ref="triangle"
                  src="../assets/img/details/icon-jiantou@2x (2).png"
                  alt=""
                />
              </div>
              <div class="proved-main">
                <div
                  class="every"
                  v-for="(item, index) in directory2.proved"
                  :key="index"
                  @click="toWatchVideo"
                >
                  <div>
                    <img
                      src="../assets/img/details/icon-bofang@2x.png"
                      alt=""
                    />
                    <div>{{ item }}</div>
                  </div>
                  <div>
                    <div>试看</div>
                  </div>
                </div>
              </div>
              <div class="proved-main" style="margin-top: 14px">
                <div
                  class="every"
                  v-for="(item, index) in directory2.noProved"
                  :key="index"
                  @click="toWatchVideo"
                >
                  <div>
                    <img
                      src="../assets/img/details/icon-bofang@2x.png"
                      alt=""
                    />
                    <div>{{ item }}</div>
                  </div>
                  <div>
                    <img
                      v-if="!courseDeatil.isBuy"
                      src="../assets/img/details/icon-suo@2x.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="course-bto" v-if="!flag">
      <div class="zixun-con">
        <div class="zixun" @click="contactTeacher">
          <img src="../assets/img/details/icon-zixun@2x.png" alt="" />
          <span>咨询</span>
        </div>
        <div class="zixun share" @click="showShare">
          <img src="../assets/img/details/icon-fenxiang@2x.png" alt="" />
          <span>分享</span>
        </div>
      </div>
      <!-- 立即购买 -->
      <div  v-if="shopId != 66138373357569">
        <div  @click="toStudyDialog()" v-if="courseDeatil.ifPurchase" class="buy-btn">去学习</div>
        <div
          v-if="courseDeatil.allowBuy&&!courseDeatil.ifPurchase"
          @click="toplatFormMsg(courseDeatil.shopId)"
          class="buy-btn">提交订单</div
        >        
      </div>
    </div>
    <div class="bound" v-if="isContactTeacher">
      <div class="bound-main">
        <img
          src="../assets/img/dianpu/icon-close@2x.png"
          class="close"
          alt=""
          @click="closeContactTeacher"
        />
        <img :src="liaison.headImgUrl" class="touxiang" alt="" />
        <div class="user-name">{{ liaison.nickName }}</div>
        <div class="hint">感兴趣请联系推荐人</div>
        <div
          class="btn"
          v-clipboard="liaison.phone"
          @success="handleCopy(true)"
          @error="handleCopy(false)"
          @click="closeContactTeacher"
        >
          复制微信手机号
        </div>
      </div>
    </div>
    <shareMoney
      v-if="isShowShare"
      @closeShare="closeShare"
      :courseDetail="courseDeatil"
    ></shareMoney>
    <shareShop
      v-else-if="isShareShop"
      @closeShare="closeShare"
      :courseDetail="courseDeatil"
    ></shareShop>
    <!---新手指引--->
    <van-overlay :show="notNewUser" class="mypopup">
      <div class="con1 pop" v-if="guideImgIndex == 1" @click="nextPopup">
        <img
          src="../assets/images/guide/jpg-dianpu@2x.png"
          alt=""
          class="guide-border1"
          :style="'padding-top:' + shopInfoTop + 'px'"
        />
        <div class="shop-info">
          <div class="shop">
            <div class="user-img">
              <img :src="shopMsg.logo" alt="" />
              <div class="shop-name">
                <p>{{ shopMsg.shopName }}的店铺</p>
              </div>
            </div>
            <div class="rg">
              <img src="../assets/img/details/icon-jiantou@2x.png" alt="" />
            </div>
          </div>
        </div>
        <div class="next">下一步</div>
      </div>
      <div class="con2 pop" v-else-if="guideImgIndex == 2" @click="nextPopup">
        <div class="next" :style="'margin-top:' + tabsTop + 'px'">下一步</div>
        <img
          src="../assets/images/guide/jpg-xiangqingmulu@2x.png"
          alt=""
          class="guide-border2"
        />
        <div class="course-main">
          <div class="course-main-top">
            <div class="tab active-tab">
              <span>详情</span>
              <div></div>
            </div>
            <div class="tab">
              <span>目录</span>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="con3 pop"
        v-else-if="guideImgIndex == 3 && shopId != 66138373357569"
        @click="nextPopup"
      >
        <div class="bottom-box">
          <div class="next">下一步</div>
          <img
            src="../assets/images/guide/jpg-lijigoumai@2x.png"
            alt=""
            class="guide-border3"
          />
          <div class="buy-box">
            <span class="buy-btn">立即购买</span>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 顶部固定栏 -->
    <div class="fixed-top" v-show="false">
      <div class="course-main-top">
        <div
          :class="tabIndex == 1 ? 'tab active-tab' : 'tab'"
          @click="changeTab(1)"
        >
          <span>详情</span>
          <div></div>
        </div>
        <div
          v-if="!flag"
          :class="tabIndex == 2 ? 'tab active-tab' : 'tab'"
          @click="toStudyDialog(), changeTab(2)"
        >
          <span>目录</span>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { List, Swipe, SwipeItem, Toast, Popup, Overlay } from "vant";
import shareMoney from "../components/popupWindow/shareMoney";
import shareShop from "../components/popupWindow/shareShop";
import api from "../api/api";
import MtaH5 from "mta-h5-analysis";
import { Dialog } from "vant";
import Clipboard from "clipboard";
import utils from '../utils/utils';

export default {
  components: {
    shareMoney,
    shareShop,
  },
  data() {
    return {
      flag: "", //审核隐藏
      currentTab: 0,
      version: localStorage.getItem("version"), //版本号
      returnVersion: localStorage.getItem("returnVersion"), //返回的版本号
      shopId: 0,
      productId: 0,
      courseId: 0,
      courseIds: [],
      purchasedCourseTitles: [],
      purchasedPage: "",
      liaison: {
        phone: 0,
      },
      income: 0,
      shopMsg: {},
      courseDeatil: {},
      directory: [{}, {}],
      //套餐试看视频
      schemeFreeVideoList: [],
      toVideoSchemeFreeVideoList: [],
      totalVideoCount: "",
      directory2: {
        proved: [
          "母婴护理入门指南",
          "从零基础学习婴儿的拥姿从零基础从零基础学习婴儿的拥姿从零基础",
          "从零基础学习婴儿的拥姿",
        ],
        noProved: [
          "1. 从零基础学习婴儿的拥姿从零基础学习婴儿的拥姿从零基础",
          "2. 母婴护理入门指南",
          "3. 从零基础学习婴儿的拥姿从零基础",
        ],
      },
      // tab切换
      tabIndex: 1,
      // 是否联系老师
      isContactTeacher: false,
      // 是否展示分享
      isShowShare: false,
      //是否展示店铺（不带钱的）分享
      isShareShop: false,
      //  章节目录列表
      listLesson: [],
      //  章节下标
      listLessonIndex: 0,

      videoIndex: 0,

      notNewUser: false,
      guideImgIndex: 1,
      shopInfoTop: 0,
      tabsTop: 0,
      isShowFixedTop: false,
      isLoadVideoPreBack: "", //是否加载片头片尾
      // 轮播列表
      swiperList: [],

      isLogin:false,
      isAndroid: true,

    };
  },
  async created() {
    document.title = "店铺";
    document.body.style.overflow = "auto";
    let flag = localStorage.getItem("flag");
    this.flag = (flag == "true") ? true : false;
    if (Object.keys(this.$route.params).length != 0) {
      Object.keys(this.$route.params).filter((item) => {
        localStorage.setItem(item, this.$route.params[item]);
      });
    }
    this.shopId = this.$route.params.shopId || localStorage.getItem("shopId");
    this.productId = this.$route.params.productId || localStorage.getItem("productId");
    let visite = this.$route.params.visite;
    if (visite === 1) {
      this.addVisitLog(this.$route.params.inviteCode);
    } else {
      this.addVisitLog("");
    }
    //判断用户是否登录
    await this.getUserInfo()
    this.loadShopInfo(this.shopId);
    MtaH5.pgv();
    await this.getDetail();
    this.hiddePlatformShop();
    //是否加载片头片尾
    this.getIsLoadVideoPreBack();
    // 判断设备
    this.isAndroid = utils.isAndroid();
  },
  mounted() {
    this.$nextTick(function() {
      if(!this.flag){
        let shopInfoTop = document.getElementById("shopInfo").offsetTop;
      }
      this.shopInfoTop = 269; //shopInfoTop 245

      let tabsTop = document.getElementById("tabs").getBoundingClientRect().top;
      this.tabsTop = 270.6; //tabsTop 244.6
      //如果第一次进入，新手指引
      let notNewUser = localStorage.getItem("notNewUser");
      if (!notNewUser) {
        this.notNewUser = true;
        localStorage.setItem("notNewUser", true);
      }
    });
    window.addEventListener("scroll", this.getPageOffset);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getPageOffset);
  },
  methods: {
    getSwiperVideo() {
      let params = {
        productId: this.productId,
        courseId: this.courseId,
      };
      api.getCourseDetailsSwiperVideo(params).then((res) => {
        let videoData = res.data.videoShow;
        let imagesData = res.data.imageShow;
        imagesData = imagesData.map((item) => {
          return {
            url: item,
            type: "image",
          };
        });
        if (videoData.length != 0 && !this.flag) {
          videoData = videoData.map((item) => {
            return {
              url: item,
              type: "video",
            };
          });
          this.swiperList = videoData.concat(imagesData);
          this.$nextTick(() => {
            // 隐藏video的三点按钮
            document.getElementById("courseVideo")[
              "disablePictureInPicture"
            ] = true;
          });
        } else {
          this.swiperList = imagesData;
        }
      });
    },
    changeCourseVideo(index) {
      let videoDom = document.getElementById("courseVideo");
      if (index !== 0) {
        videoDom.pause();
      } else {
        videoDom.play();
      }
    },
    changeSwiper(index) {
      this.tabIndex = index + 1;
    },
    // 获取常量
    getListConstant() {
      api.getImgBase64;
    },
    // 页面滑动一定高度后固定详情和目录于顶部
    getPageOffset() {
      let nodeOffset = document.getElementById("fixedTop").offsetTop;
      let pageOffset = window.pageYOffset;
      if (pageOffset > nodeOffset) {
        this.isShowFixedTop = true;
      } else {
        this.isShowFixedTop = false;
      }
    },
    // 复制
    copy(str) {
      let save = function(e) {
        e.clipboardData("text/plain", str);
        e.preventDefault();
      };
      document.addEventListener("copy", save);
      document.execCommand("copy");
    },
    // 复制成功和失败的回调
    handleCopy(sign) {
      sign ? this.$toast("复制成功"):this.$toast("复制失败"); // ui组件使用的是vant
    },
    // 收起列表
    packUp(index, lessonId) {
      if (this.listLessonIndex != index && this.courseIds.length == 1) {
        let target = this.$refs.provedMain[this.listLessonIndex];
        let triangle = this.$refs.triangle[this.listLessonIndex];
        target.style = "display:none;height:0;";
        triangle.style = "transform:rotateZ(180deg)";
        this.listLessonIndex = index;
      }
      let target = this.$refs.provedMain[index];
      let triangle = this.$refs.triangle[index];
      if (target.dataset.status == "open") {
        target.style = "display:none;height:0;";
        triangle.style = "transform:rotateZ(180deg)";
        target.dataset.status = "close";
      } else {
        target.removeAttribute("style");
        triangle.removeAttribute("style");
        this.listLesson = [];
        if (this.courseIds.length == 1) {
          this.getListCatalogue(lessonId);
        }
        target.dataset.status = "open";
      }
    },
    // 去购买
    toBuy() {
      //判断是否登录 未登录跳转登录
      let productId = localStorage.getItem("productId");
      let shopId = localStorage.getItem("shopId");
      this.$router.push({
        path: "/sureOrder",
        query: {
          productId: productId,
          shopId: shopId,
          shopName: this.shopMsg.shopName,
          shopLogo: this.shopMsg.logo,
          inviteCode: this.$route.params.inviteCode,
        },
      });
    },
    // 提示去学习
    toStudyDialog(totalSort) {
      if (this.courseDeatil.ifPurchase) {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "您已购买，现在要学习吗？",
            confirmButtonText: "", //改变确认按钮上显示的文字
            cancelButtonText: "稍后学习", //改变取消按钮上显示的文字
          })
          .then(() => {
            let courseId = this.courseId;
            let total = this.totalVideoCount;
            let sort = totalSort;
            if (sort == undefined || sort == 0) {
              sort = 1;
            }
            //跳转到视频播放界面
            //wx.miniProgram.navigateTo({url: "../../courseContent/video/video?courseId="+courseId+"&total="+total+"&sort="+sort});
            //跳转到已购界面
            wx.miniProgram.redirectTo({
              url: "../../switchPage?into=0&flag=normal",
            });
          })
          .catch(() => {});
      }
    },
    /**
     * 隐藏官方店铺购买按钮
     */
    hiddePlatformShop() {
      if (this.shopId == 66138373357569) {
      }
    },
    //平台店铺提示不可购买
    async toplatFormMsg(shopId) {
      if (!this.isLogin) {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "您还未登录",
            confirmButtonText: "去登录", //改变确认按钮上显示的文字
            //cancelButtonText: "稍后学习" //改变取消按钮上显示的文字
          })
          .then(() => {
            //跳转到登录界面
            wx.miniProgram.navigateTo({
              url:
                "../../login/wxLogin/wxLogin?productId=" +
                this.productId +
                "&shopId=" +
                this.shopId,
            });
          })
          .catch(() => {
          });
      } else {
        //如果是单一商品单个课程，正常去购买
        if (
          this.courseIds.length == 1 ||
          (this.courseIds.length > 1 && this.purchasedCourseTitles.length == 0)
        ) {
          this.toBuy();
          //套餐商品
        } else {
          //如果相等，套餐里课程已经全部购买，
          if (this.courseIds.length == this.purchasedCourseTitles.length) {
            //TO DO 不做操作，暂时留着
            //传来的coursId有多个值，套餐内未购买课程
            //如果不相等，说明套餐商品内有课程已经购买，但不是全部课程
          } else {
            var purchasedCourse = "";
            for (var i = 0; i < this.purchasedCourseTitles.length; i++) {
              purchasedCourse =
                purchasedCourse + "【" + this.purchasedCourseTitles[i] + "】";
            }
            this.$dialog
              .confirm({
                title: "温馨提示",
                message:
                  "您之前已购买过" + purchasedCourse + ",是否要继续购买？",
                confirmButtonText: "立即购买", //改变确认按钮上显示的文字
                cancelButtonText: "我再想想", //改变取消按钮上显示的文字
              })
              .then(() => {
                this.toBuy();
                // console.log("点击了确认按钮噢");
              })
              .catch(() => {
                // console.log("点击了取消按钮噢");
              });
          }
        }
      }
    },
    //去店铺首页
    toShop() {
      let params = {
        shopId: this.shopId,
      };
      this.$router.push({ name: "shop", params: params });
    },
    //获取店铺信息
    loadShopInfo(shopId) {
      let param = {
        shopId: shopId,
      };
      api
        .getShopInfo(param)
        .then((res) => {
          this.shopMsg = res.data;
        })
        .catch((err) => {});
    },
    // 联系老师
    contactTeacher() {
      document.body.style.overflow = "hidden";
      let params = {
        shopId: this.shopId,
      };
      api
        .getShopContact(params)
        .then((res) => {
          if (res.success) {
            this.liaison = res.data;
            this.isContactTeacher = true;
          } else {
            Toast(res.msg);         
          }
        })
        .catch((res) => {
          Toast(res.msg);
          return;
        });
    },
    // 关闭联系老师
    closeContactTeacher() {
      document.body.style.overflow = "auto";
      this.isContactTeacher = false;
    },
    // 展示分享
    async showShare() {
      if (!this.isLogin) {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "您还未登录",
            confirmButtonText: "去登录", //改变确认按钮上显示的文字
            //cancelButtonText: "稍后学习" //改变取消按钮上显示的文字
          })
          .then(() => {
            //跳转到登录界面
            wx.miniProgram.navigateTo({
              url:
                "../../login/wxLogin/wxLogin?productId=" +
                this.productId +
                "&shopId=" +
                this.shopId,
            });
            //wx.miniProgram.navigateTo({url: "../../login/wxLogin/wxLogin?productId="+this.productId+"&shopId="+this.shopId});
          })
          .catch(() => {
          });
      } else {
        document.body.style.overflow = "hidden";
        this.shareIncome();
      }
    },
    // 关闭分享
    closeShare() {
      document.body.style.overflow = "auto";
      this.isShowShare = false;
      this.isShareShop = false;
    },
    // tab切换
    changeTab(index) {
      this.tabIndex = index;
      this.$refs["swiper"].swipeTo(index - 1);
    },
    // 选择要观看的视频
    toWatchVideo() {
      if (this.version != this.returnVersion) return;

      if (this.courseDeatil.ifPurchase) {
        let path = "";
        if (this.isLoadVideoPreBack == "true") {
          path = "/video";
        } else {
          path = "/video2";
        }
        this.$router.push({
          path,
          query: {},
        });
      } else {
        Toast("还未购买");
      }
    },
    // 选择试看视频
    toProved(num) {
      //单商品对应单课程
      if (this.courseIds.length == 1) {
        let path = "";
        if (this.isLoadVideoPreBack == "true") {
          path = "/video";
        } else {
          path = "/video2";
        }
        this.$router.push({
          path,
          query: {
            freeVideoList: this.directory[0].courseList,
            courseCatagory: this.courseDeatil.courseCatagory,
            videoIndex: num,
          },
        });
      } else if (this.courseIds.length > 1) {
        let path = "";
        if (this.isLoadVideoPreBack == "true") {
          path = "/video";
        } else {
          path = "/video2";
        }
        for (var i = 0; i < this.schemeFreeVideoList.length; i++) {
          for (var j = 0; j < this.schemeFreeVideoList[i].list.length; j++) {
            this.schemeFreeVideoList[i].list[j].title =
              "【" +
              this.schemeFreeVideoList[i].courseTitle +
              "】" +
              this.schemeFreeVideoList[i].list[j].title;
            this.toVideoSchemeFreeVideoList.push(
              this.schemeFreeVideoList[i].list[j]
            );
          }
        }
        this.$router.push({
          path,
          query: {
            freeVideoList: this.toVideoSchemeFreeVideoList,
            courseCatagory: this.courseDeatil.courseCatagory,
            videoIndex: num,
          },
        });
      }
    },
    // 新增访问记录
    addVisitLog(inviteCode) {
      let params = {
        shopId: this.shopId,
        productId: this.productId,
      };
      //如果存在邀请码 则传入邀请码
      if ("" !== this.inviteCode && undefined !== this.inviteCode) {
        params.inviteCode = this.inviteCode;
        MtaH5.clickStat("qrcode_open_course", {});
      } else {
        MtaH5.clickStat("open_course", {});
      }
      api
        .visitLog(params)
        .then()
        .catch();
    },
    //获取详情接口
    async getDetail() {
      let params = {
        productId: this.productId,
        shopId: this.shopId,
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      await api
        .detail(params)
        .then((res) => {
          // console.log(res, "商品详情");
          if (res.success) {
            Toast.clear();
            this.courseDeatil = res.data;
            this.courseIds = res.data.courseId;
            this.purchasedCourseTitles = res.data.purchasedCourseTitle;
            //商品对应一个课程
            if (this.courseIds.length == 1) {
              this.courseId = this.courseIds[0];
              // console.log(this.courseId);
              this.getListLesson(this.courseId);
              //商品套餐对应多课程
            } else if (this.courseIds.length > 1) {
              for (var i = 0; i < this.courseIds.length; i++) {
                this.getFreeVideo(this.courseIds[i]);
              }
            }
            //已购课程界面过来的分享弹窗
            let url = this.$route.params;
            this.purchasedPage = url["purchasedPage"];
            if (this.purchasedPage == "purchasePage") {
              this.productId = url["productId"];
              this.shopId = url["shopId"];
              this.showShare();
            }
            if (res.data.status == "disable") {
              this.$dialog
                .alert({
                  width: "280",
                  message: "该商品已经下架",
                  lockScroll: true,
                })
                .then(() => {
                  wx.miniProgram.redirectTo({
                    url: "../../switchPage?into=0&flag=normal",
                  });
                });
            }
            // 获取轮播数据
            this.getSwiperVideo();
          
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    //章节列表接口
    async getListLesson(courseId) {
      let params = {
        courseId: courseId,
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api
        .listLesson(params)
        .then((res) => {
          // console.log(res, "章节列表");
          if (res.success) {
            Toast.clear();
            this.directory[1].courseList = res.data;
            this.getFreeVideo(courseId);
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    //  试看接口
    async getFreeVideo(courseId) {
      let params = {
        courseId: courseId,
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api
        .freeVideo(params)
        .then((res) => {
          if (res.success) {
            Toast.clear();
            //单个商品单个课程
            if (this.courseIds.length == 1) {
              this.directory[0].courseList = res.data.list;
              if (this.directory[1].courseList[0] != undefined) {
                this.getTotalVideoCount(
                  this.directory[1].courseList[0].lessonId
                );
              }
              //单商品多课程套餐
            } else if (this.courseIds.length > 1) {
              this.schemeFreeVideoList.push(res.data);

              let index = 0;
              for (var i = 0; i < this.schemeFreeVideoList.length; i++) {
                for (
                  var j = 0;
                  j < this.schemeFreeVideoList[i].list.length;
                  j++
                ) {
                  this.schemeFreeVideoList[i].list[j].num = index++;
                }
              }
            }
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    //  章节目录列表
    getListCatalogue(id) {
      let params = {
        courseId: this.courseId,
        lessonIds: id,
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api
        .listCatalogue(params)
        .then((res) => {
          if (res.success) {
            Toast.clear();
            this.listLesson = res.data.list[0].list;
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    //  获取总视频数量
    getTotalVideoCount(id) {
      let params = {
        courseId: this.courseId,
        lessonIds: id,
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api
        .listCatalogue(params)
        .then((res) => {
          if (res.success) {
            Toast.clear();
            this.totalVideoCount = res.data.total;
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    // 分享赚钱
    shareIncome() {
      let params = {
        productId: this.productId,
      };
      api
        .income(params)
        .then((res) => {
          if (res.success) {
            Toast.clear();
            let items = res.data;
            //分享开关关闭 或者分享的钱等于0
            if (!items.open || items.income == 0) {
              this.isShareShop = true;
              this.isShowShare = false;
            } else {
              this.isShowShare = true;
              this.isShareShop = false;
            }
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          Toast("系统错误");
        });
    },
    nextPopup() {
      if (
        (this.shopId == 66138373357569 && this.guideImgIndex == 2) ||
        this.guideImgIndex >= 3
      ) {
        return (this.notNewUser = false);
      }
      this.guideImgIndex++;
    },
    //是否加载片头片尾
    getIsLoadVideoPreBack() {
      let params = {
        name: "videoBeginEndEnable",
      };
      let that = this;
      api
        .getListConstant(params)
        .then((res) => {
          if (res.success) {
            that.isLoadVideoPreBack = res.data.content;
          } else {
            Toast(res.msg);
            return;
          }
        })
        .catch((err) => {
          Toast("系统异常!");
        });
    },
    //判断用户是否登录
    async getUserInfo(){
      let that=this
      await api.getUserInfo().then(res=>{
        if(res.success){
          that.isLogin=true
        }else{
          if(res.status==2){
            Toast.clear() //清除提示
          }
        }
      }).catch(err=>{
        return
      })
    },

  },
};
</script>
<style lang="scss" scoped>
body {
  background-color: #fff !important;
}
.courseDetails {
  box-sizing: border-box;
  padding-top: 12px;
  .course-name,
  .course-tags,
  .price-studys,
  .shop-info {
    box-sizing: border-box;
    padding: 0 12px;
  }
  .course-imgs {
    width: 100%;
    height: 16.125rem;
    .course-img-swiper {
      width: 100%;
      height: 100%;
      .course-video,
      .course-img {
        width: 100%;
        height: 100%;
      }
      .course-video:focus{
        outline: -webkit-focus-ring-color auto 0px;
      }
      .van-swipe-item {
        box-sizing: border-box;
        padding: 0 12px;
      }
      .course-img {
        border-radius: 4px;
        box-shadow: 0px 0px 10px #e9e3e3;
      }
    }
  }
  .course-name {
    margin-top: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    text-align: left;
  }
  .course-tags {
    display: flex;
    align-items: center;
    margin: 10px 0 10px;
    .tag {
      width: 46px;
      height: 20px;
      line-height: 20px;
      background: #fff2ec;
      border-radius: 4px;
      color: #ff7303;
      font-size: 12px;
    }
    .tag:not(:first-child) {
      margin-left: 10px;
    }
  }
  .price-studys {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .price {
      display: flex;
      align-items: center;
      .new-price {
        font-size: 20px;
        color: #ff5534;
      }
    }
    .old-price,
    .studys {
      font-size: 12px;
      color: #6a6a6a;
    }
    .old-price {
      margin-left: 14px;
      text-decoration: line-through;
    }
  }
  .shop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ff5542;
    border-radius: 10px;
    padding: 10px;
    margin-top: 1rem;
    .user-img {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .shop-name {
        display: flex;
        align-items: center;
        margin-left: 10px;
        //   font-size: 15px;
        color: #feeee0;
        p {
          white-space: nowrap;
        }
        p:first-child {
          width: 11.625rem;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }
      }
    }
    .rg {
      width: 18px;
      height: 18px;
      img {
        width: 100%;
      }
    }
  }
  .course-main {
    margin-top: 1.1rem;
    background-color: #f8f8f8;
    padding-bottom: 3.625rem;
    .course-main-top {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 14px 0;
      background-color: #f8f8f8;
      .tab {
        span {
          color: #666666;
        }
      }
      .active-tab {
        position: relative;
        span {
          color: #333333;
          font-weight: bold;
        }
        div {
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          // margin: 0 auto;
          width: 30px;
          height: 3px;
          background: linear-gradient(270deg, #f74c12 0%, #fd7d32 100%);
          border-radius: 5px;
        }
      }
    }
    .course-detail {
      box-sizing: border-box;
      padding: 14px 12px 0;
      img {
        width: 100%;
      }
    }
    .freevideo-course {
      font-weight: bold;
      padding-left: 10px;
      text-align: left;
    }
    .directory {
      .and-proved {
        .proved-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 12px;
          & > div {
            font-weight: bold;
          }
          & > img {
            width: 14px;
            height: 14px;
          }
        }
        .proved-main {
          padding: 0 14px;
          border-radius: 8px;
          background-color: #fff;
          .every {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;
            border-bottom: 1px solid rgba(232, 232, 232, 0.5);
            & > div:first-child {
              display: flex;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
              div {
                width: 15.5rem;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                color: #333;
                font-size: 15px;
              }
            }
            & > div:last-child {
              div {
                font-size: 12px;
                color: #fc6360;
                padding: 2px;
                border-radius: 2px;
                background-color: rgba(252, 99, 96, 0.1);
              }
              img {
                width: 14px;
                height: 14px;
              }
            }
          }
          .every:last-child {
            border: 0;
          }
        }
      }
    }
  }

  .course-bto {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 1rem;
    box-sizing: border-box;
    border-top: 1px solid #f8f8f8;
    background-color: #fff;
    // display: none;
    .zixun-con {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .zixun {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          margin-left: 4px;
          color: #333333;
          font-weight: bold;
        }
      }
      .share {
        img {
          position: relative;
          top: 2px;
        }
      }
    }
    .buy-btn {
      width: 120px;
      height: 38px;
      line-height: 38px;
      background: #ff6060;
      border-radius: 23px;
      color: #fff;
    }
  }
  .bound {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    .bound-main {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18rem;
      padding: 20px;
      background-color: #fff;
      transform: translate(-50%, -50%);
      border-radius: 6px;
      .close {
        position: absolute;
        top: -36px;
        right: 0px;
        width: 27px;
        height: 27px;
      }
      .touxiang {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      .user-name {
        margin: 10px 0;
      }
      .hint {
        font-size: 14px;
      }
      .btn {
        width: 140px;
        height: 40px;
        background: #ff6060;
        border-radius: 20px;
        margin: 24px auto 0;
        color: #fff;
        line-height: 40px;
        font-size: 14px;
      }
    }
  }
  .mypopup {
    width: 100vw;
    height: 100vh;
    // background-color: transparent;
    color: white;
    .pop {
      height: 100vh;
      overflow: hidden;
    }
    .con1 {
      // min-height: 100vh;
      text-align: right;
    }
    .guide-border1 {
      // padding-top: 215px;
      width: 204px;
      height: 112px;
      margin-right: 22px;
    }
    .shop-info {
      margin: 0;
      .shop {
        margin-top: 0;
      }
    }
    .con2 {
      .guide-border2 {
        width: 262px;
        height: 105px;
      }
      .course-main {
        padding-bottom: 0;
        margin-top: 0;
      }
    }
    .con3 {
      text-align: right;
      position: relative;
      .bottom-box {
        position: absolute;
        bottom: 9px;
        right: 2%;
      }
      .guide-border3 {
        width: 263px;
        height: 94px;
      }
      .buy-box {
        padding-right: 2%;

        .buy-btn {
          width: 100px;
          height: 38px;
          line-height: 38px;
          background: #ff6060;
          border-radius: 23px;
          color: #fff;
          text-align: center;
          display: inline-block;
        }
      }
    }
    .next {
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient(131deg, #d92b58 0%, #ff5542 100%);
      border-radius: 19px;
      color: #fff;
      margin: 0 auto;
    }
    .con1 {
      .next {
        margin-top: 84px;
      }
    }
    .con2 {
      .next {
        margin-bottom: 27px;
      }
    }
    .con3 {
      .next {
        margin-bottom: 35px;
      }
    }
  }
}
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #f8f8f8;
  .course-main-top {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 14px 0;
    .tab {
      span {
        color: #666666;
      }
    }
    .active-tab {
      position: relative;
      span {
        color: #333333;
        font-weight: bold;
      }
      div {
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        // margin: 0 auto;
        width: 30px;
        height: 3px;
        background: linear-gradient(270deg, #f74c12 0%, #fd7d32 100%);
        border-radius: 5px;
      }
    }
  }
}
.my-swipe .van-swipe-item{
  height: calc(100vh - 57px - 49px);
  overflow: auto;
}
</style>
